import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export async function archiveReportFn(axiosInstance: Promise<AxiosInstance>, id: string) {
  const instance = await axiosInstance;

  const data = instance.put(`/reports/export_tasks/${id}/archive`);
  return data;
}

export function useArchiveReport() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, string>({
    mutationFn: id => archiveReportFn(axiosInstance, id),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ['reports'],
      });
    },
  });

  return addActionNameToMutationResult<ApiResponse, ApiError, string, 'archiveReport'>(
    'archiveReport',
    mutation,
  );
}
